<template>
  <el-button
    :class="customType + ' button'"
    :size="size"
    :type="type"
    :plain="plain"
    :round="round"
    :loading="loading || loadingStatus"
    :disabled="disabled"
    :icon="icon"
    :autofocus="autofocus"
    :nativeType="nativeType"
    @click="click"
    >
    <slot></slot>
  </el-button>
</template>

<script>
  export default {
    name: 'AppButton',
    props: {
      size: String,
      type: String,
      plain: Boolean,
      round: Boolean,
      loading: Boolean,
      disabled: Boolean,
      icon: String,
      autofocus: Boolean,
      nativeType: String,
      customType: String, // defatult
      asyncClick: Function,
    },
    data() {
      return {
        loadingStatus: false,
      }
    },
    methods: {
      click(event) {
        this.$emit('click', event);
        if (this.asyncClick) {
          const res = this.asyncClick()
          if (res instanceof Promise) {
            this.loadingStatus = true;
            res.then(() => {
              this.loadingStatus = false;
            }).catch(() => {
              this.loadingStatus = false;
            })
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

.button {
  height: 1.8vw;
  padding-top: 0;
  padding-bottom: 0;
}
.default {
  background: #239efb;
  color: #fff;
  padding: 0 1.4vw;
  font-size: 0.8vw;
  letter-spacing: 2px;
  border-radius: 0.4vw;
  border: none;
  &:hover {
    background: #5eb3f5;
  }
}
</style>